
function Kids() {

    return (
        <div>
            <main>
                <section>
                    <div className="banner">
                        <img className='header-image' src="/assets/city-img/playground_banner.jpg" alt="Spielplatz" />
                    </div>
                </section>
                <div className="content">
                    <article>
                        <div className="text">
                            <h1>Mit Kind und Kegel</h1>
                            <p>Auch für kleinere Erdenbürger hat Wismar einiges zu bieten. Wenn all die Gebäude, Straßen und  
                                Strände von den Erwachesene begutachtet wurden und auch die zigste Sandburg errichtet worden 
                                ist, ist es endlich Zeit für Lern-, Spiel- und Tobespaß.
                            </p>
                        </div>
                        <div className="text">
                            <h2>phanTECHNIKUM</h2>
                            <p>Für alle, die in die spannende Welt von Maschinen, Fahrzeugen und allerlei nicht-digitaler 
                                Technik eintauchen wollen. Zum Bestaunen, Anfassen und Mitmachen. Schon mal gesehen, wie 
                                ein tonnenschwerer Schiffsmotor aussieht? Oder Fahrräder vor 100 Jahren? Wusstest du, dass 
                                der erste Schleudersitz für Piloten in MeckPomm erfunden wurde? Dies und viele weitere 
                                spanndende Dinge gibt es im phanTECHNIKUM zu bestaunen.
                            </p>
                        </div>
                        <div className="text">
                            <h2>Indoorspielpark</h2>
                            <p>Hier können sich große und kleine Kinder so richtig austoben, gerade wenn das Wetter mal 
                                nicht so toll ist. In Wismar gibt es gleich zwei Indoorspielparks: Mumpitz und Wonniland. 
                                Mit jeder Menge Aktivitätsstationen, die jeden Bewegungsdrang mitmachen.
                            </p>
                        </div>
                        <div className="text">
                            <h2>Piratentour</h2>
                            <p>Die Bootstour mit Unterhaltungsfaktor an Board. In waschechter Piratenkleidung und allem, was 
                                ein Piratenabenteuer auf hoher See ausmacht. Garantiert nicht so langweilig wie mit den 
                                Erwachsenen immer nur Häuser und Wasser angucken.
                            </p>
                        </div>
                        <div className="text">
                            <h2>Wonnemar</h2>
                            <p>Schwimmen, plantschen, Spaß haben. Strand zu voll oder Wetter zu regnerisch? Im Erlebnisbad 
                                kommen kleine und große Wasserratten auf ihre Kosten. Hier können sich nicht nur Kinder 
                                austoben, sondern auch Erwachsene mit Sauna oder Spa einen entspannten Tag verbringen.
                            </p>
                        </div>
                        <div className="text">
                            <h2>Kindermotorland</h2>
                            <p>An der Wohlenberger Wiek geht es rasant zu. Für richtig viel Action und Speed-Spaß bietet sich 
                                das Kindermotorland an. Von März bis Oktober können Kiddies ab 7 Jahren auf Motorrädern oder 
                                in Buggies ihre Runden drehen.
                            </p>
                        </div>
                    </article>
                </div>
            </main>
        </div>
    )
}

export default Kids;